import { BindingCreator } from '@dreryk/react-common';
import { Textarea } from '@dreryk/react-components';

import { referralTranslationKeys } from '../translations';

const ADDITIONAL_INFORMATION_FIELD_NAME = 'additionalInformation';
type AdditionalInformationFormBeanPart = {
   [ADDITIONAL_INFORMATION_FIELD_NAME]: string | null;
};
type AdditionalInformationFieldProps = {
   readonly register: BindingCreator<AdditionalInformationFormBeanPart>;
};

export const AdditionalInformationTextarea = (props: AdditionalInformationFieldProps): JSX.Element => {
   return (
      <Textarea
         rows={3}
         maxRows={5}
         maxLength={3600}
         focus={false}
         label={referralTranslationKeys.additionalInformation}
         controller={props.register(ADDITIONAL_INFORMATION_FIELD_NAME)}
         placeholder={referralTranslationKeys.insertAdditionalInformation}
         testId={'additionalInformation'}
      />
   );
};
